import { Button, Input } from 'semantic-ui-react';
import useRememberCredentials from 'src/components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from 'src/components/helpers/RememberCredentialsCheckbox';
import { PageWrapper, StepCard, StepTitle, StepSubtitle, FormGroup } from './styles';

export default function LoginStep({
  inputs,
  setInputs,
  errorInputs,
  setErrorInputs,
  loading,
  onSubmit,
}) {
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs });

  const clearError = (name) => {
    if (setErrorInputs) {
      setErrorInputs((prev) => ({ ...prev, [name]: false }));
    }
  };

  const handleSubmit = (e) => {
    persistCredentials({
      identification: inputs.identification,
      phone: inputs.phone,
    });
    onSubmit(e);
  };

  return (
    <PageWrapper>
      <StepCard>
        <StepTitle>Marcar mi asistencia</StepTitle>
        <StepSubtitle>
          Ingresa tu identificación y celular para ver y registrar tu asistencia en Crecer o
          seminarios.
        </StepSubtitle>
        <form onSubmit={handleSubmit}>
          {Object.values(errorInputs).some(Boolean) && (
            <p style={{ color: '#e74c3c', marginBottom: 12 }}>
              Por favor verifica los campos en rojo.
            </p>
          )}
          <FormGroup className={errorInputs.identification ? 'error' : ''}>
            <label htmlFor="identification">Identificación</label>
            <Input
              id="identification"
              name="identification"
              type="number"
              placeholder="Identificación"
              value={inputs.identification}
              onChange={(e) => {
                setInputs((prev) => ({ ...prev, identification: e.target.value }));
                clearError('identification');
              }}
            />
          </FormGroup>
          <FormGroup className={errorInputs.phone ? 'error' : ''}>
            <label htmlFor="phone">Celular</label>
            <Input
              id="phone"
              name="phone"
              type="number"
              placeholder="Celular"
              value={inputs.phone}
              onChange={(e) => {
                setInputs((prev) => ({ ...prev, phone: e.target.value }));
                clearError('phone');
              }}
            />
          </FormGroup>
          <RememberCredentialsCheckbox
            checked={rememberCredentials}
            onChange={setRememberCredentials}
          />
          <FormGroup className={errorInputs.whoSentTheLink ? 'error' : ''}>
            <label htmlFor="whoSentTheLink">¿Quién te facilitó el enlace?</label>
            <Input
              id="whoSentTheLink"
              name="whoSentTheLink"
              placeholder="Nombre de la persona"
              value={inputs.whoSentTheLink}
              onChange={(e) => {
                setInputs((prev) => ({ ...prev, whoSentTheLink: e.target.value }));
                clearError('whoSentTheLink');
              }}
            />
          </FormGroup>
          <Button primary type="submit" disabled={loading} loading={loading}>
            Continuar
          </Button>
        </form>
      </StepCard>
    </PageWrapper>
  );
}
